export enum SubscriptionDurationIndicator {
   MuchTimeLeft,
   MediumTimeLeft,
   AlmostOver
}